import React from 'react';
import educationData from '../../educationData';

export default function EducationCard(props) {
	// console.log('EducationCard', props);
	console.log("kjhhjkj", educationData);

		return (
		<div className="EducationCard md:mx-4 min-w-80 my-4 p-7 rounded-md shadow-lg border">
			<img
				src="https://matt-hoelzel.s3.us-west-1.amazonaws.com/quantic_logo.png"
				className="float-left mr-4 bg-[url('/assets/quantic_logo')]"
				alt="quantic-logo"
			/>
			<h2 className="text-sm md:text-lg text-blue-500 hover:underline">
				<strong>
					<a
						href="https://quantic.edu/executive-mba"
						target="_blank"
						className="flex content-start"
					>
						{educationData[0].schoolName}
					</a>
				</strong>
			</h2>
			<h3 className="text-md lg:text-lg">
				Executive Masters of Business Administration (EMBA)
			</h3>
			<ul className="list-disc ml-4 md:ml-6 mt-2 mb-5 font-thin text-md lg:text-base clear-left pt-3">
				<li>
					Award-winning MBA curriculum offered in a completely mobile format
				</li>
				<li>Graduated with Honors</li>
			</ul>
		</div>
	);
}
